'use strict';
'use es6';

/**
 * Useful when a rejection may be called with a non-Error value.
 * Throws an instance of window.Error, but returns any other value.
 *
 * @param  {any}
 * @return {any}
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rethrowError = rethrowError;
function rethrowError(err) {
  if (err instanceof Error) {
    throw err;
  }
  return err;
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/core/PromiseHandlers.js
// module id = 171
// module chunks = 3 4 5